module.exports = __webpack_public_path__ + "static/media/ragnarsson.941e3c11.jpg";